import { JSX } from "react";
import { cn } from "web-design-system";

interface Props {
  children: JSX.Element;
  className?: string;
}

export default function CenteredContainer({ children, className }: Props) {
  return (
    <div
      className={cn(
        "flex justify-center items-center",
        "w-dvw h-dvh",
        className
      )}
    >
      {children}
    </div>
  );
}
